import React, { useState } from "react";
import Box from "components/shared/Box";
import FormField from "components/shared/Form/formField";
import Button from "components/shared/Button";

const FormPreview = ({
  metaData,
  fields,
  setFields,
  handleMoveFieldUp,
  handleMoveFieldDown,
  handleDeleteField,
  FieldEditor, // Accept FieldEditor as a prop
}) => {
  const [editingFieldIndex, setEditingFieldIndex] = useState(null);
  const [isAddingField, setIsAddingField] = useState(false);

  const handleEditField = (index) => {
    setEditingFieldIndex(index);
    setIsAddingField(false); // Ensure we're not in "add field" mode
  };

  const handleSaveEditedField = (updatedField) => {
    const updatedFields = [...fields];
    updatedFields[editingFieldIndex] = updatedField;
    setFields(updatedFields);
    setEditingFieldIndex(null);
  };

  const handleAddNewField = () => {
    setIsAddingField(true);
    setEditingFieldIndex(null); // Ensure we're not editing an existing field
  };

  const handleSaveNewField = (newField) => {
    setFields([...fields, newField]);
    setIsAddingField(false);
  };

  const handleCancelAddField = () => {
    setIsAddingField(false);
  };

  return (
    <Box
      className="preview-box"
      size="big"
      cover={metaData.cover}
      title={{ type: "accent", text: metaData.name + "" }}
    >
      {metaData.description && (
        <p className="form__description feedback-form__description">
          {metaData.description}
        </p>
      )}
      <div className="feedback-form__questions">
        {fields.map((field, index) => (
          <div
            key={`field-${index}`}
            className="question-wrapper"
            style={{ position: "relative" }}
          >
            {editingFieldIndex === index ? (
              <FieldEditor
                field={field}
                onSave={(updatedField) => handleSaveEditedField(updatedField)}
                onCancel={() => setEditingFieldIndex(null)}
                fullWidth={false} // Inline editing
              />
            ) : (
              <>
                <FormField {...field} name={"q-" + index} onChange={() => {}} />
                <div className="feedback-form__field-actions">
                  <Button
                    onClick={() => handleMoveFieldUp(index)}
                    type="secondary"
                    className={"form-builder__move-up"}
                    text=""
                  ></Button>
                  <Button
                    onClick={() => handleMoveFieldDown(index)}
                    type="secondary"
                    text=""
                    className={"form-builder__move-down"}
                  >
                    Down
                  </Button>
                  <Button
                    onClick={() => handleEditField(index)}
                    className={"form-builder__edit"}
                    type="secondary"
                  ></Button>
                  <Button
                    onClick={() => handleDeleteField(index)}
                    className={"form-builder__delete"}
                    type="secondary"
                  ></Button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
      {isAddingField ? (
        <FieldEditor
          field={{ type: "short", label: "", explainer: "" }}
          onSave={(newField) => handleSaveNewField(newField)}
          onCancel={handleCancelAddField}
          fullWidth={true} // Full-width for adding a new field
        />
      ) : (
        <Button
          text="Add Field"
          onClick={handleAddNewField}
          type="secondary"
          size="large"
          className={"add-field-prompt"}
        />
      )}
    </Box>
  );
};

export default FormPreview;
